import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../actions/auth';
import { Login } from '../../components/auth';

const mapStateToProps = (state, ownProps) => ({
  isAuthenticating: state.auth.isAuthenticating,
  queryNext: ownProps.location.query.next,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

class LoginPage extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    isAuthenticating: PropTypes.bool.isRequired,
    queryNext: PropTypes.string,
  };

  onLoginClick = credentials => {
    const { actions, queryNext } = this.props;

    actions.loginUser(credentials, queryNext);
  };

  render() {
    const { isAuthenticating } = this.props;

    return <Login isAuthenticating={isAuthenticating} onLoginClick={this.onLoginClick} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)


// WEBPACK FOOTER //
// ./src/containers/auth/LoginPage.js